import React, { useEffect, useState } from "react";
import img4 from '../../../Assets/add/img4.png';
import img3 from '../../../Assets/add/img3.png';
import rightarrow from '../../../Assets/navbar/right-arrow.svg';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from "react-router-dom";
import rightArrow from '../../../Assets/navbar/right-arrow.svg';
import DummyMapFromOLA from "../../../Component/Customers/DummyMapFromOLA";

import mediumCraneImage from '../../../Assets/crane/mediumCrane.jpg';
import largeCraneImage from '../../../Assets/crane/largeCrane.jpg';

import mediumFlatbedImage from '../../../Assets/crane/mediumFlatbed.jpg';
import largeFlatBedImage from '../../../Assets/crane/largeFlatBed.jpg';

import mediumRecoveryVanImage from '../../../Assets/crane/mediumRecoveryVan.png'
import miniRecoveryVanImage from '../../../Assets/crane/miniRecoveryVan.jpg'
import largeRecoveryVanImage from '../../../Assets/crane/largeRecoveryVan.jpg'
import { Download } from "lucide-react";


export default function TestMapLoader({
    setPickupLocation,
    isLoading,
    handleSubmit,
    isModalWaitingProp,
    setIsModalWaiting,
    pickupLocation,
    setDropLocation,
    dropLocation,
    setChooseFromSelectedServiceFinal,
    setCurrentStep,
    vehicleType,
    setVehicleType,
    stats = {},
    distance,
    vendorData,
    setAccidentDataObject,
    chooseFromSelectedServiceFinal,
    chooseFromSelectedSubServiceFinal,
    quantity,
    unloadWeight
}) {

    console.log('pickupLocation', pickupLocation)
    console.log('dropLocation', dropLocation)

    const [startLoader, setStartLoader] = useState(false);
    const [selectedServiceType, setSelectedServiceType] = useState('');
    const [tripType, setTripType] = useState("one-way");
    const { navigate } = useNavigate()
    console.log('vehicleType', vehicleType)
    sessionStorage.setItem('hasRetriedOnce', 'false');

    const craneTypes = ['mediumCrane', 'largeCrane'];
    console.log('quantity', quantity)
    const formData = localStorage.getItem('formData');
    const parsedData = JSON.parse(formData);
    const { Vehicle_rc_unld_wt } = parsedData?.additionalData || {};
    console.log('vehicleRCUNLOAD', Vehicle_rc_unld_wt);
    console.log('quantity + Vehicle_rc_unld_wt',parseInt(quantity) + parseInt(Vehicle_rc_unld_wt))
    const filteredCraneTypes = (parseInt(quantity) + parseInt(Vehicle_rc_unld_wt)) > 14000
        ? craneTypes.filter(type => type !== 'mediumCrane')
        : craneTypes;


    const recoveryVanTypes = ['miniRecoveryVan', 'mediumRecoveryVan', 'largeRecoveryVan'];

    let filteredRecoveryVanTypes = [];

    if (chooseFromSelectedSubServiceFinal == "Non-flat-bed") {
        if (unloadWeight <= 3000) {
            // Allow all types
            filteredRecoveryVanTypes = recoveryVanTypes;
        } else if (unloadWeight > 3000 && unloadWeight <= 15000) {
            // Remove miniRecoveryVan
            filteredRecoveryVanTypes = recoveryVanTypes.filter(type => type !== 'miniRecoveryVan');
        } else if (unloadWeight > 15000) {
            // Only allow largeRecoveryVan
            filteredRecoveryVanTypes = ['largeRecoveryVan'];
        }
    }
    if (chooseFromSelectedSubServiceFinal == "Flat-bed") {
        if (unloadWeight <= 3000) {
            // Allow all types
            filteredRecoveryVanTypes = recoveryVanTypes.filter(type => type !== 'miniRecoveryVan');
        } else if (unloadWeight > 3000 && unloadWeight <= 15000) {
            // Remove miniRecoveryVan
            filteredRecoveryVanTypes = recoveryVanTypes.filter(type => type !== 'miniRecoveryVan');
        } else if (unloadWeight > 15000) {
            // Only allow largeRecoveryVan
            filteredRecoveryVanTypes = ['largeRecoveryVan'];
        }
    }



    useEffect(() => {
        localStorage.removeItem("AccidentVehicleCode");
        localStorage.removeItem("paymentDetails");
        localStorage.setItem("hasRetriedOnce", "false");
        window.scrollTo(0, 0);
    }, []);

    const {
        miniCrane = {},
        mediumCrane = {},
        largeCrane = {},
        miniRecoveryVan = {},
        mediumRecoveryVan = {},
        largeRecoveryVan = {}
    } = stats;

    console.log('statis', stats)
    console.log('vendorData', vendorData)
    console.log('quantity', quantity)
    console.log('chooseFromSelectedSubServiceFinal', chooseFromSelectedSubServiceFinal)
    console.log('unloadWeight', unloadWeight)




    vehicleType = vehicleType?.split(',')
    const loadModal = () => {
        setIsModalWaiting(true);
    };

    useEffect(() => {
        let pickupLoc = localStorage.getItem('pickupLoc')
        let vehicleType = localStorage.getItem('vehicleType')
        let dropLoc = localStorage.getItem('dropLoc')
        console.log(dropLoc)
        setPickupLocation(pickupLoc)
        setDropLocation(dropLoc)
        setVehicleType(vehicleType)
    })
    console.log('stats', stats)
    console.log('data?.vendorDriverIds?.length', stats?.vendorDriverIds?.length)


    return (
        <div className="
    w-full                       
    mx-auto                      /* center horizontally           */
    mb-12                        /* bottom margin                 */
    font-sans text-sm bg-white
    rounded-lg overflow-hidden
  ">
            <div className="  relative w-full
      min-h-[30vh]                /* phones                       */
        ">
                {/* <img
                    src="https://www.kaashivinfotech.com/tutorial/wp-content/uploads/2020/06/Google-Map-US_10.jpg"
                    alt="Map"
                    className="w-full h-full object-cover"
                /> */}
                <DummyMapFromOLA />

                <div className="absolute inset-0 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="150" height="150">
                        <g fill="none" stroke="#1770AD" strokeWidth="2">
                            <circle cx="22" cy="22" r="1">
                                <animate attributeName="r" values="1; 20" dur="1.8s" repeatCount="indefinite" />
                                <animate attributeName="stroke-opacity" values="1; 0" dur="1.8s" repeatCount="indefinite" />
                            </circle>
                            <circle cx="22" cy="22" r="1">
                                <animate attributeName="r" values="1; 20" dur="1.8s" begin="0.9s" repeatCount="indefinite" />
                                <animate attributeName="stroke-opacity" values="1; 0" dur="1.8s" begin="0.9s" repeatCount="indefinite" />
                            </circle>
                        </g>
                    </svg>
                </div>
            </div>


            {/* Locations */}
            <div className="p-4 border-b">
                <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-green-500 rounded-full mt-1" />
                    {/* <span className="text-[12px] md:text[17px]"><span className="font-bold text-xs"> Breakdown / Accident Spot: </span> {pickupLocation}</span> */}
                    <span className="text-[12px] md:text-[15px]">
                        <span className="font-bold text-xs md:text-[15px]">Breakdown Spot:</span>{" "}
                        {pickupLocation?.split(" ").slice(0, 3).join(" ") + (pickupLocation?.split(" ").length > 3 ? "..." : "")}
                    </span>

                </div>
                <div className="flex items-center space-x-2 mt-2">
                    <div className="w-2 h-2 bg-red-500 rounded-full mt-1" />
                    <span className="text-[12px] md:text-[15px]">
                         <span className="font-bold text-xs md:text-[15px]"> Destination Location: </span>
                        {dropLocation?.split(" ").slice(0, 3).join(" ") + (dropLocation?.split(" ").length > 3 ? "..." : "")}</span>
                </div>
            </div>

            {/* Service Options */}
            <div className="text-left text-[12px] font-bold px-4 py-1 text-blue-500 border-b md:text-[15px]">
                SELECT VEHICLE<span className="font-semibold"></span>
            </div>

            <div className="space-y-4 mb-[5rem] sm:px-[0.5rem] md:p-4">
                {/* Crane Types */}

                {vehicleType?.includes('crane') &&
                    filteredCraneTypes.map((type) => {
                        const data = stats[type] || {};
                        return (
                            <div key={type} onClick={() => {
                                if (isLoading || !data?.vendorDriverIds?.length) return;
                                setChooseFromSelectedServiceFinal(type); // still set this for UI
                                setSelectedServiceType(type);
                                const selectedData = stats[type];
                                const selectedVendors = vendorData.filter(v =>
                                    selectedData?.vendorDriverIds?.includes(v.vendorDriverId)
                                );
                                console.log('selectedData', selectedData)
                                console.log('selectedVendors', selectedVendors)


                                const summaryData = {
                                    chooseFromSelectedServiceFinal: type,
                                    vendorData: JSON.stringify(selectedVendors),
                                    minAmount: selectedData?.minAmount,
                                    maxAmount: selectedData?.maxAmount,
                                    minDuration: selectedData?.minDuration,
                                    nonGSTCharge: selectedData?.nonGSTCharge,
                                    maxDuration: selectedData?.maxDuration,
                                    estimateUrl: selectedData?.estimateUrl,
                                    pickupLocation: pickupLocation,
                                    dropLocation: dropLocation
                                };
                                console.log('summarydata', summaryData)

                                setAccidentDataObject(prev => ({
                                    ...prev,
                                    ...summaryData
                                }));
                            }}
                                style={{
                                    border: selectedServiceType === type ? '2px solid black' : 'none'
                                }}
                                className={`
  flex items-center mx-[1rem] justify-between rounded-lg p-2 px-[1rem] cursor-pointer
  ${selectedServiceType === type ? 'shadow-md' : ''}
  ${(isLoading || !data?.vendorDriverIds?.length) ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-lg'}
`}

                            >
                                <div className="flex items-center space-x-3">
                                    {type == 'mediumCrane' && (<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumCrane.jpg' alt={type} className="w-12 h-12 object-contain" />)}
                                    {type == 'largeCrane' && (<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/largeCrane.jpg' alt={type} className="w-12 h-12 object-contain" />)}

                                    <div>
                                        <div className="font-semibold ">{type.replace('Crane', '').replace(/^./, (c) => c.toUpperCase())}</div>
                                        {/* <div className="text-gray-500 text-xs">economical</div> */}
                                        {/* {type == 'miniCrane' && (<div className="text-gray-500 text-xs">like : <span className="opacity-90">Farana 14</span></div>)} */}
                                        {type == 'mediumCrane' && (<div className="text-gray-500 text-xs">like : <span className="opacity-90">Farana 14</span></div>)}
                                        {type == 'largeCrane' && (<div className="text-gray-500 text-xs">like : <span className="opacity-90">Farana 24</span></div>)}

                                    </div>
                                </div>
                                <div className="text-right font-semibold whitespace-nowrap">
                                    {isLoading ? (
                                        <div hidden className="loader2 h-[20px] w-[15px]"></div>
                                    ) : !data || data.vendorDriverIds?.length === 0 ? (
                                        <p className="text-red-500 text-sm">Vendor's Not Available</p>
                                    ) : (
                                        <div className="flex flex-col">
                                            {/* <div>₹{data.minAmount?.toFixed(2)} – ₹{data.maxAmount?.toFixed(2)}</div> */}
                                            <div>Amount : ₹{data.maxAmount?.toFixed(2)}</div>

                                            <div className="flex gap-[0.5rem]">
                                                {/* <div>{data.minDuration} – {data.maxDuration}</div> */}
                                                <div> ETA Duration : {data.maxDuration}</div>

                                                {/* <Download
                                                    onClick={() => {
                                                        const link = document.createElement('a');
                                                        link.href = data.estimateUrl; // ✅ remove {} around URL
                                                        const formattedType = type.replace('Crane', '').replace(/^./, (c) => c.toUpperCase()); // ✅ fix template literal
                                                        link.download = `${formattedType}.docx`; // ✅ corrected string template
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                    }}
                                                    className="text-blue-500 cursor-pointer h-[1rem]"
                                                /> */}

                                            </div>
                                            {/* <p className="text-[11px]">Trip Estimate</p> */}
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                }

                {/* Recovery Van Types */}
                {vehicleType?.includes('recoveryVan') && chooseFromSelectedSubServiceFinal == "Non-flat-bed" &&
                    filteredRecoveryVanTypes.map((type) => {
                        const data = stats[type] || {};
                        return (
                            <div key={type} onClick={() => {
                                if (isLoading || !data?.vendorDriverIds?.length) return;
                                setChooseFromSelectedServiceFinal(type); // still set this for UI
                                setSelectedServiceType(type);
                                const selectedData = stats[type];
                                const selectedVendors = vendorData.filter(v =>
                                    selectedData?.vendorDriverIds?.includes(v.vendorDriverId)
                                );
                                console.log('selectedData', selectedData)
                                console.log('selectedVendors', selectedVendors)
                                const summaryData = {
                                    chooseFromSelectedServiceFinal: type,
                                    vendorData: JSON.stringify(selectedVendors),
                                    minAmount: selectedData?.minAmount,
                                    maxAmount: selectedData?.maxAmount,
                                    minDuration: selectedData?.minDuration,
                                    maxDuration: selectedData?.maxDuration,
                                    nonGSTCharge: selectedData?.nonGSTCharge,
                                    estimateUrl: selectedData?.estimateUrl,
                                    pickupLocation: pickupLocation,
                                    dropLocation: dropLocation
                                };
                                console.log('summarydata', summaryData);

                                setAccidentDataObject(prev => ({
                                    ...prev,
                                    ...summaryData
                                }));
                            }}
                                style={{
                                    border: selectedServiceType === type ? '2px solid black' : 'none'
                                }}
                                className={`
  flex items-center mx-[1rem] justify-between rounded-lg p-2 px-[1rem] cursor-pointer
  ${selectedServiceType === type ? 'shadow-md' : ''}
  ${(isLoading || !data?.vendorDriverIds?.length) ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-lg'}
`}
                            >
                                <div className="flex text-left items-center space-x-3">
                                    {type == 'miniRecoveryVan' && (<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/miniRecoveryVan.jpg' alt={type} className="w-12 h-12 object-contain" />)}
                                    {type == 'mediumRecoveryVan' && (<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumRecoveryVan.png' alt={type} className="w-12 h-12 object-contain" />)}
                                    {type == 'largeRecoveryVan' && (<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/largeRecoveryVan.jpg' alt={type} className="w-12 h-12 object-contain" />)}

                                    {/* <img src={img4} alt={type} className="w-12 h-12 object-contain" /> */}
                                    <div>
                                        <div className="font-semibold text-md md:text-[15px]">{type.replace('RecoveryVan', '').replace(/^./, (c) => c.toUpperCase())}</div>
                                        {type == 'miniRecoveryVan' && (<div className="text-gray-500 text-sm">like : <span className="opacity-90">Tata 207</span></div>)}
                                        {type == 'mediumRecoveryVan' && (<div className="text-gray-500 text-sm">like : <span className="opacity-90">Tata 709</span></div>)}
                                        {type == 'largeRecoveryVan' && (<div className="text-gray-500 text-sm">like : <span className="opacity-90">Tata 1613</span></div>)}

                                    </div>
                                </div>
                                <div className="text-right font-semibold whitespace-nowrap">
                                    {isLoading ? (
                                        <div hidden className="loader2 h-[20px] w-[15px]"></div>
                                    ) : !data || data.vendorDriverIds?.length === 0 ? (
                                        <p className="text-[12px]  text-red-500 text-sm md:text[15px]">Vendor's Not Available</p>
                                    ) : (
                                        <div className="flex flex-col">
                                            {/* <div className="text-[12px] md:text[15px]">₹{data.minAmount?.toFixed(2)} – ₹{data.maxAmount?.toFixed(2)}</div> */}
                                            <div className="text-[13px] md:text[18px] font-semibold"> Amount : ₹{data.maxAmount?.toFixed(2)}</div>

                                            <div className="flex gap-[1rem]">
                                                {/* <div className="text-[11px] md:text[14px]">{data.minDuration} – {data.maxDuration}</div> */}
                                                <div className="text-[11px] md:text[14px]"> ETA Duration : {data.maxDuration}</div>
                                                {/* 
                                                <Download
                                                    onClick={() => {
                                                        const link = document.createElement('a');
                                                        link.href = data.estimateUrl; // ✅ remove {} around URL
                                                        const formattedType = type.replace('RecoveryVan', '').replace(/^./, (c) => c.toUpperCase()); // ✅ fix template literal
                                                        link.download = `${formattedType}.docx`; // ✅ corrected string template
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                    }}
                                                    className="text-blue-500 cursor-pointer h-[1rem] mt-[0.3rem]"
                                                /> */}
                                            </div>
                                            {/* <p className="text-[11px]">Trip Estimate</p> */}

                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}

                {vehicleType?.includes('recoveryVan') && chooseFromSelectedSubServiceFinal == "Flat-bed" &&
                    filteredRecoveryVanTypes.map((type) => {
                        const data = stats[type] || {};
                        return (
                            <div key={type} onClick={() => {
                                if (isLoading || !data?.vendorDriverIds?.length) return;
                                setChooseFromSelectedServiceFinal(type); // still set this for UI
                                setSelectedServiceType(type);
                                const selectedData = stats[type];
                                const selectedVendors = vendorData.filter(v =>
                                    selectedData?.vendorDriverIds?.includes(v.vendorDriverId)
                                );
                                console.log('selectedData', selectedData)
                                console.log('selectedVendors', selectedVendors)
                                const summaryData = {
                                    chooseFromSelectedServiceFinal: type,
                                    vendorData: JSON.stringify(selectedVendors),
                                    minAmount: selectedData?.minAmount,
                                    maxAmount: selectedData?.maxAmount,
                                    minDuration: selectedData?.minDuration,
                                    maxDuration: selectedData?.maxDuration,
                                    nonGSTCharge: selectedData?.nonGSTCharge,
                                    estimateUrl: selectedData?.estimateUrl,
                                    pickupLocation: pickupLocation,
                                    dropLocation: dropLocation
                                };
                                console.log('summarydata', summaryData);

                                setAccidentDataObject(prev => ({
                                    ...prev,
                                    ...summaryData
                                }));
                            }} style={{
                                border: selectedServiceType === type ? '2px solid black' : 'none'
                            }}
                                className={`
  flex items-center mx-[1rem] justify-between rounded-lg p-2 px-[1rem] cursor-pointer
  ${selectedServiceType === type ? 'shadow-md' : ''}
  ${(isLoading || !data?.vendorDriverIds?.length) ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-lg'}
`}

                            >
                                <div className="flex items-center space-x-3">
                                    {type == 'mediumRecoveryVan' && (<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/mediumFlatbed.jpg' alt={type} className="w-12 h-12 object-contain" />)}
                                    {type == 'largeRecoveryVan' && (<img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/largeFlatBed.jpg' alt={type} className="w-12 h-12 object-contain" />)}

                                    {/* <img src={img4} alt={type} className="w-12 h-12 object-contain" /> */}
                                    <div>
                                        <div className="font-semibold">{type.replace('RecoveryVan', '').replace(/^./, (c) => c.toUpperCase())}</div>
                                        {type == 'mediumRecoveryVan' && (<div className="text-gray-500 text-xs">like : <span className="opacity-90">Tata 709</span></div>)}
                                        {type == 'largeRecoveryVan' && (<div className="text-gray-500 text-xs">like : <span className="opacity-90">Tata 1613</span></div>)}

                                    </div>
                                </div>
                                <div className="text-right font-semibold whitespace-nowrap">
                                    {isLoading ? (
                                        <div hidden className="loader2 h-[20px] w-[15px]"></div>
                                    ) : !data || data.vendorDriverIds?.length === 0 ? (
                                        <p className="text-[12px]  text-red-500 text-sm md:text[15px]">Vendor's Not Available</p>
                                    ) : (
                                        <div className="flex flex-col">
                                            {/* <div className="text-[12px] md:text[15px]">₹{data.minAmount?.toFixed(2)} – ₹{data.maxAmount?.toFixed(2)}</div> */}
                                            <div className="text-[12px] md:text[15px]"> Amount : ₹{data.maxAmount?.toFixed(2)}</div>

                                            <div className="flex gap-[1rem]">
                                                {/* <div className="text-[11px] md:text[14px]">{data.minDuration} – {data.maxDuration}</div> */}
                                                <div className="text-[11px] md:text[14px]">ETA Duration : {data.maxDuration}</div>
                                                {/* 
                                                <Download
                                                    onClick={() => {
                                                        const link = document.createElement('a');
                                                        link.href = data.estimateUrl; // ✅ remove {} around URL
                                                        const formattedType = type.replace('RecoveryVan', '').replace(/^./, (c) => c.toUpperCase()); // ✅ fix template literal
                                                        link.download = `${formattedType}.docx`; // ✅ corrected string template
                                                        document.body.appendChild(link);
                                                        link.click();
                                                        document.body.removeChild(link);
                                                    }}
                                                    className="text-blue-500 cursor-pointer h-[1rem] mt-[0.3rem]"
                                                /> */}
                                            </div>
                                            {/* <p className="text-[11px]">Trip Estimate</p> */}

                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
            </div>

            {/* Review Booking */}

            <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] ">
                <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full  gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                    <button
                        onClick={() => setCurrentStep('03')}

                        className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"

                    >
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="back" className="h-[24px] w-[24px] rotate-180" />
                        Back
                    </button>
                    <button
                        disabled={!chooseFromSelectedServiceFinal}
                        onClick={() => {
                            handleSubmit();
                            setStartLoader(true);
                            // setCurrentStep('05')
                        }}
                        className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full ${chooseFromSelectedServiceFinal == null
                            ? "bg-[#a7dbf5] cursor-not-allowed"
                            : "bg-[#21A6E9] hover:bg-[#1e94d6]"
                            }`}
                    >
                        Continue
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="continue" className="h-[24px] w-[24px]" />
                    </button>


                </div>
            </div>           

            {/* Modal */}
            {/* <ModalForWaiting
                isOpen={isModalWaitingProp}
                onClose={() => setIsModalWaiting(false)}
            /> */}
        </div>
    );
}

function ModalForWaiting({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            {/* <div className="bg-white py-10 px-8 md:px-12 rounded-[30px] shadow-xl w-[90%] max-w-[536px] relative text-center">
                <div className="flex flex-col items-center justify-center gap-4">
                    <ClipLoader size={30} color="#21A6E9" />
                    <p className="text-lg font-medium text-gray-700">
                        ⏳ Waiting for response...
                    </p>
                    <p className="text-sm text-gray-500">
                        Please hang tight while we process your request.
                    </p>
                </div>

                <div className="mt-10 flex justify-center">
                    <div
                        onClick={onClose}
                        className="bg-[#EE3840] flex items-center py-2 px-6 rounded-full cursor-pointer hover:bg-red-600 transition duration-300"
                    >
                        <span className="text-white font-medium text-base mr-3">Close</span>
                        <img src={rightarrow} className="h-6 w-6" alt="arrow" />
                    </div>
                </div>
            </div> */}


        </div>
    );
}
